/*
  Odenwälder BabyNest: Verhalten der schwebenden Navigation
  - Mega-Menü öffnet am Desktop beim Überfahren mit der Maus (Klick und Tastatur bleiben wie bei Dawn)
  - Klasse od-nav--menu-open für Abdunkelung und Kartenform
  - --header-height bleibt aktuell, damit der erste Abschnitt der Startseite richtig hinter der Karte beginnt
*/
(() => {
  const wrapper = document.querySelector('.od-nav');
  if (!wrapper) return;

  const sectionHeader = wrapper.closest('.section-header');
  const card = wrapper.querySelector('.header');
  const desktopHover = window.matchMedia('(min-width: 1200px) and (hover: hover)');
  const OPEN_DELAY = 80;
  // Ist schon ein Menü offen, wird erst nach kurzer Pause gewechselt, damit ein
  // schräger Weg zum Dropdown über einen Nachbarpunkt nicht das Menü tauscht
  const SWITCH_DELAY = 160;
  const CLOSE_DELAY = 300;

  const menus = Array.from(wrapper.querySelectorAll('header-menu'));
  const detailsOf = (menu) => menu.querySelector('details');

  const syncOpenState = () => {
    const isOpen = menus.some((menu) => detailsOf(menu).hasAttribute('open'));
    wrapper.classList.toggle('od-nav--menu-open', isOpen);
  };

  const openMenu = (menu) => {
    menus.forEach((other) => {
      if (other !== menu && detailsOf(other).hasAttribute('open')) other.close();
    });
    const details = detailsOf(menu);
    if (details.hasAttribute('open')) return;
    details.setAttribute('open', '');
    details.querySelector('summary').setAttribute('aria-expanded', 'true');
  };

  let openTimer;
  let closeTimer;
  const anyOpen = () => menus.some((menu) => detailsOf(menu).hasAttribute('open'));

  menus.forEach((menu) => {
    const details = detailsOf(menu);
    const summary = details.querySelector('summary');

    details.addEventListener('toggle', syncOpenState);

    // Geöffnet wird nur über den Menüpunkt selbst, nicht über das Dropdown
    summary.addEventListener('mouseenter', () => {
      if (!desktopHover.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(() => openMenu(menu), anyOpen() ? SWITCH_DELAY : OPEN_DELAY);
    });

    summary.addEventListener('mouseleave', () => clearTimeout(openTimer));
  });

  // Einfache Menüpunkte ohne Dropdown schließen ein offenes Mega-Menü
  wrapper.querySelectorAll('.header__inline-menu > ul > li > a').forEach((link) => {
    link.addEventListener('mouseenter', () => {
      if (!desktopHover.matches || !anyOpen()) return;
      clearTimeout(openTimer);
      openTimer = setTimeout(() => menus.forEach((menu) => menu.close()), SWITCH_DELAY);
    });
    link.addEventListener('mouseleave', () => clearTimeout(openTimer));
  });

  // Geschlossen wird erst, wenn die Maus die Karte samt Dropdown verlässt.
  // So bleibt das Menü auch auf dem Weg durch den Rand zwischen Menüpunkt und Dropdown offen.
  if (card) {
    card.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    card.addEventListener('mouseleave', () => {
      if (!desktopHover.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => menus.forEach((menu) => menu.close()), CLOSE_DELAY);
    });
  }

  // Klick auf die Abdunkelung schließt das Menü
  wrapper.addEventListener('click', (event) => {
    if (event.target === wrapper && wrapper.classList.contains('od-nav--menu-open')) {
      menus.forEach((menu) => menu.close());
    }
  });

  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') menus.forEach((menu) => menu.close());
  });

  // Mobilmenü: Unterkante der Karte für die Höhe des Menüs merken,
  // Body-Klasse zum Ausblenden der App-Symbole (Chat, Cookie) setzen
  const drawerDetails = wrapper.querySelector('header-drawer > details');
  if (drawerDetails && card) {
    const setCardBottom = () => {
      document.documentElement.style.setProperty('--od-card-bottom', `${Math.round(card.getBoundingClientRect().bottom)}px`);
    };
    drawerDetails.querySelector('summary').addEventListener('click', setCardBottom);
    window.addEventListener('resize', () => {
      if (drawerDetails.hasAttribute('open')) setCardBottom();
    });
    new MutationObserver(() => {
      document.body.classList.toggle('od-drawer-open', drawerDetails.hasAttribute('open'));
    }).observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
  }

  if (sectionHeader && 'ResizeObserver' in window) {
    new ResizeObserver(() => {
      document.documentElement.style.setProperty('--header-height', `${sectionHeader.offsetHeight}px`);
    }).observe(sectionHeader);
  }
})();
